module.exports = __webpack_public_path__ + "static/hero-section-bg-afb0dd183c1ba731b8713e566d91a919.png";